import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 34px 34px 0;
  width: 100%;
  position: relative;
  z-index: 1;
`;
